import React from 'react';
import { Col, Row } from 'reactstrap';

export default function ConnetionWrapper({
  conectionTestDetails,
  onReload,
  heading,
  speedBoxInProgress,
}) {
  return (
    <div className="containerTest">
      <div style={{ 'margin-bottom': '15px', 'margin-top': '15px' }}>
        <span className="under-line font-weight-bold ">{heading}</span>
        {/* {speedBoxInProgress && <span className="">(Last Run: 09/05/2023)</span>} */}
        {speedBoxInProgress && (
        <div className="mb-1 conectionDetails">
          <h1>LTE Test in progress. Please check back in 5-10 minutes.</h1>
        </div>
      )}
        
      </div>
      {conectionTestDetails ? (
        <table className="table-condenced" style={{ 'border-collapse': 'collapse' }}>
          {conectionTestDetails?.map((item, index) => (
            <tr>
              <td style={{ backgroundColor: '#8080802e', width: '50%' }}> {item?.name}</td>
              <td>{item?.value}</td>
            </tr>
          ))}
         
        </table>
      ) : (
       ''
      )}
     
      <span onClick={onReload} className='btn btn-primary btn-sm'>Run </span>

           
    </div>
  );
}